import WireModal from "./WireModal"
import OpenWireModalButton from "./OpenWireModalButton"

export default WireModal

export { OpenWireModalButton }
